// store/index.js
 
import Vue from "vue";
import Vuex from "vuex";
 
Vue.use(Vuex);
 
export default new Vuex.Store({
 state: {
     usuario:[],
     usuarioActual:'',
     idActual:'',
     fotoActual:'',
     mensaje:'Holahola'

 },
 getters: {},
 mutations: {
    GET_USUARIO(state,dato){
        state.usuarioActual=dato
      },
      GET_ID(state,dato){
        state.idActual=dato
      },
      GET_FOTO(state,dato){
        state.fotoActual=dato
      },
 },
 actions: {}
});


// WEBPACK FOOTER //
// ./src/store/index.js